if (!customElements.get('cbn-announcement')) {
 customElements.define('cbn-announcement', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   this.stop();
   if (!this.hasAttribute('data-rotate')) return;
   const options = {signal:this.controller.signal};
   this.messages = [...this.querySelectorAll('[data-message]')];
   this.index = 0;
   this.addEventListener('mouseenter', () => this.stop(), options);
   this.addEventListener('mouseleave', () => this.start(), options);
   document.addEventListener('visibilitychange', () => this.start(), options);
   this.start();
  }
  start() {
   this.stop();
   if (document.hidden) return;
   this.timer = setInterval(() => {
    this.messages[this.index].hidden = true;
    this.index = (this.index + 1) % this.messages.length;
    this.messages[this.index].hidden = false;
   }, 5000);
  }
  stop() { clearInterval(this.timer); }
  disconnectedCallback() { this.stop(); this.controller?.abort(); }
 });
}
